import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {ConversationAgentSquadContainerModel} from "../../../../../../../models/aggregates/alg/cc/conversation";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable({providedIn: 'root'})
export class ConversationAgentSquadService extends BaseApiTemplateService<ConversationAgentSquadContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation-agent-squad';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation-agent-squad';
    this.httpClient = http;
  }
}
